let $doc = $(document);

function StickyNav() {
    let $doc = $(document);
    let $header = $doc.find('header');
    let $body = $doc.find('body');

    let $secondaryNav = $doc.find('.notification, .breadcrumbs-schedules');
    let $headerBottom = $header.offset().top + $header.innerHeight();

    let isSecondaryNavAvailable = $secondaryNav.length > 0;

    let marginFix = -22;

    if( isSecondaryNavAvailable ) {

        let $clientTop = window.pageYOffset;

        let isNavbarVisible = ($clientTop <= ($headerBottom + marginFix));

        if( !isNavbarVisible ) {
            $body.addClass("sticky-nav");
        } else {
            $body.removeClass("sticky-nav");
        }
    }
}

function sum(sum, num) {
    return sum + num;
}

function StickyFooter() {
    let $client = window;
    let $doc = $(document);
    let $mainContainer = $doc.find('main');

    let $navbar = $doc.find('body > nav.navbar');
    let $secondaryNavbar = $doc.find('body > nav.secondary-navbar');
    let $header = $doc.find('body > header');
    let $footer = $doc.find('body > footer');
    let $banner = $doc.find('body > div.banner');

    let clientHeight = $client.innerHeight;
    let mainContainerHeight = $mainContainer.height() || 0;
    let navbarHeight = parseInt($navbar.css('height')) || 0;
    let secondaryNavbarHeight = parseInt($secondaryNavbar.css('height')) + 2 || 0;
    let bannerHeight = parseInt($banner.css('height')) || 0;
    let headerHeight = parseInt($header.css('height')) || 0;
    let headerMargin = parseInt($header.css('margin-bottom')) || 0;
    let footerHeight = $footer.innerHeight() || 0;

    let boxWtMargin = $mainContainer.find('.paperbox, section.container');
    let ctaAvailable = $mainContainer.find('.cta.navigation').length;
    let numberOfBoxes = boxWtMargin.length;

    let boxesMargin = numberOfBoxes > 1 && !ctaAvailable ? parseInt(boxWtMargin.css('margin-bottom')) : 0;

    let marginFix = 0;

    let contentHeight = [
        navbarHeight,
        headerHeight,
        headerMargin,
        footerHeight,
        marginFix,
        // boxesMargin * numberOfBoxes,
        // -secondaryNavbarHeight, // the secondary navbar is negative space which is included on the header
        bannerHeight
    ].reduce(sum, 0);

    $mainContainer.css({ 'min-height': clientHeight - contentHeight });

    /* ----------------- test ----------------- */
    // let values = {
    //     clientHeight,
    //     contentHeight,
    //     mainContainerHeight,
    //     navbarHeight,
    //     secondaryNavbarHeight,
    //     headerHeight,
    //     headerMargin,
    //     bannerHeight,
    //     footerHeight,
    //     numberOfBoxes,
    //     boxesMargin,
    //
    // };
    // console.log(values);
    /* ----------------- test ----------------- */
}

function init(recalculateFooter) {
    StickyNav();
    StickyFooter();

    if(recalculateFooter){
        setTimeout(function(){
            StickyFooter();
        }, 100);
    }
}

let revealInputs = [
    '[data-reveal-field]',
    '[data-uncheck-field]',
    '[data-check-field]',
    '[data-lazy-reveal-field]',
    '[data-lazy-check-field]',
    '#filter-search'
].join(',');

$(window).on('scroll resize', () => {
    StickyNav();
    StickyFooter();
});

$doc.on('turbo:load turbo:render', () => {
    init(true);
    $(revealInputs).on('click', () => init(true));
});